import { useEffect } from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import {
  getTeam,
  loadTeamHierarchy,
  selectHierarchy,
  selectHierarchyLoadingStatus,
  selectTeamLoadingStatus,
  userAppSelectors,
} from 'redux/slices/usersSlice.slice';
import { useAppDispatch, useAppSelector } from 'redux/storeHooks';
import Loader from '../../workflows/Loader';
import { ControlledSelect } from '@act/storybook';
import { MemberTransferRequestFormType } from '@act/shared/data-transfer-objects';

interface ControlledGuideSelectorProps {
  control: Control<MemberTransferRequestFormType>;
  errors: FieldErrors<MemberTransferRequestFormType>;
}

const ControlledGuideSelector = ({
  control,
  errors,
}: ControlledGuideSelectorProps) => {
  const dispatch = useAppDispatch();
  const hierarchyLoadingStatus = useAppSelector(selectHierarchyLoadingStatus);
  const teamLoadingStatus = useAppSelector(selectTeamLoadingStatus);
  const teamHierarchy = useAppSelector(selectHierarchy);
  const viewableGuides = userAppSelectors.useSelectCurrentGuides();

  useEffect(() => {
    async function fetchUsers() {
      await dispatch(getTeam({ params: { allViewable: true } }));
    }

    if (
      teamHierarchy?.length &&
      viewableGuides === null &&
      teamLoadingStatus !== 'loading'
    ) {
      void fetchUsers();
    }
  }, [teamHierarchy, viewableGuides]);

  useEffect(() => {
    async function fetchTeamHierarchy() {
      await dispatch(await loadTeamHierarchy());
    }

    if (teamHierarchy === null && hierarchyLoadingStatus !== 'loading') {
      void fetchTeamHierarchy();
    }
  }, [teamHierarchy]);

  return (
    <div>
      {!viewableGuides?.length && <Loader />}
      {viewableGuides?.length && (
        <ControlledSelect
          defaultValue={null}
          control={control}
          errors={errors}
          name="receivingGuideId"
          label="Select a Guide"
          options={[...viewableGuides].map(user => {
            return { label: user.name, value: user.id };
          })}
          required
          fullWidth
        />
      )}
    </div>
  );
};

export default ControlledGuideSelector;
